import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Alert, Avatar, Col, Divider, message, Popconfirm, Row, Spin } from 'antd';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import { formatDateBlog } from '../../helpers/functions';
import { use } from 'marked';
import { debounce } from 'lodash';
import Helmet from '../common/helmet';
import ImagePlaceholder from './ImagePlaceholder';
import defaultImg from '../../assets/images/blog-default-img.png';
import profileDefaultImg from '../../assets/images/profile_placeholder.png';
import '../../App.css';
import { Button } from 'antd';
const Blogs = ({ admin, keys }) => {
  const blogs = useSelector(state => state?.common?.Blogs);
  const isBlogsLoading = useSelector(state => state?.common?.isBlogsLoading);
  const isDeleteBlog = useSelector(state => state?.common?.isDeleteBlogLoading);
  const totalBlogs = useSelector(state => state?.common?.totalBlogs);
  const Blog_per_page = useSelector(state => state?.common?.Blog_per_page);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (Math.ceil(totalBlogs / Blog_per_page) >= page) {
      dispatch({ type: 'GET_BLOGS', page: page });
    } else {
      setIsFetchingMore(false);
    }
  }, [page]);

  // useEffect(() => {
  //   const handleScroll = debounce(() => {
  //     const scrollTop = document.documentElement.scrollTop;
  //     const scrollHeight = document.documentElement.scrollHeight;
  //     const clientHeight = document.documentElement.clientHeight;
  //     const scrollPercentage = ((scrollTop + clientHeight) / scrollHeight) * 100;
  //     if (scrollPercentage >= 50 && !isBlogsLoading) {
  //       setIsFetchingMore(true);
  //       setPage(prevPage => prevPage + 1);
  //     }
  //   }, 500);
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, [isBlogsLoading]);

  //  setPage(prevPage => prevPage + 1);

  useEffect(() => {
    if (!isBlogsLoading) {
      setIsFetchingMore(false);
    }
  }, [isBlogsLoading]);
  useEffect(() => {
    if (keys == '1') {
      dispatch({ type: 'GET_BLOGS', page: 1 });
    }
  }, [keys]);
  const [search, setSearch] = useState('');
  useEffect(() => {
    if (search.length > 3) {
      dispatch({ type: 'GET_BLOGS', search: search });
    }
    if (search.length === 0) {
      dispatch({ type: 'GET_BLOGS', page: 1 });
    }
  }, [search]);

  useEffect(() => {
    if (!isDeleteBlog && deleteLoading) {
      setDeleteLoading(false);
      message.success('Blog deleted successfully');
      dispatch({ type: 'GET_BLOGS' });
    }
    if (isDeleteBlog && deleteLoading) {
      setDeleteLoading(false);
      message.error('Failed to delete blog');
    }
  }, [isDeleteBlog]);

  useEffect(() => {
    setIsFetchingMore(false);
  }, [blogs.length]);

  useEffect(() => {
    if (isFetchingMore) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  }, [isFetchingMore]);

  return (
    <>
      <Helmet title="Blogs" desc="Accountizer Blogs" />
      <div class="image-main-container " style={{ width: admin ? '90%' : '100%' }}>
        {/* {!admin && <h1 style={{ marginTop: '1rem', color: 'rgba(28,100,242,.9)' }}>Blogs</h1>} */}
        {
          <div style={{ width: '100%', display: 'flex', justifyContent: 'end', 
          paddingRight: '1.7rem' }}>
            <input
              type="text"
              onChange={e => setSearch(e.target.value)}
              placeholder="Search for blogs"
              style={{
                border: '1px solid rgba(28,100,242,.9)',
                borderRadius: '5px',
                outline: 'none',
                maxWidth: '20%', 
                width: '15%',
                padding: '10px 10px',
                margin: '1rem 0rem',
                fontWeight: '500',
                fontSize: '1rem',
              }}
            />
          </div>
        }
        {isBlogsLoading && (
          <Spin
            style={{
              width: '100%',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          />
        )}
        <Row>
          {blogs?.length
            ? blogs.map((data, index) => {
                return (
                  <Col
                    key={index}
                    xxl={8}
                    xl={8}
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '.7rem',
                    }}
                  >
                    <>
                      <div
                        className="blog-card"
                        style={{
                          position: 'relative',
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          borderRadius: '3px',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          padding: '1rem',
                          minHeight: '25rem',
                        }}
                        onClick={() =>
                          navigate(admin ? `/admin/blogs/${data?.id}` : `/blogs/${data?.id}`, {
                            state: data?.id,
                          })
                        }
                      >
                        <ImagePlaceholder
                          src={data?.featured_image_thumbnail}
                          fallback={defaultImg}
                          alt="Profile Picture"
                          width="100%"
                          title={data?.title}
                        />

                        {/* <div
                          className="read-more"
                          onClick={() =>
                            navigate(admin ? `/admin/blogs/${data?.id}` : `/blogs/${data?.id}`, {
                              state: data?.id,
                            })
                          }
                          style={{
                            padding: '.5rem',
                            position: 'absolute',
                            top: '6rem',
                            backgroundColor: '#1c64f2',
                            color: 'white',
                            borderRadius: '5px',
                            cursor: 'pointer',
                          }}
                        >
                          <span style={{ marginTop: '1rem' }}>Read More..</span>
                        </div> */}

                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            marginTop: '1rem',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              gap: '.5rem',
                              alignItems: 'center',
                            }}
                          >
                            {data?.author_image_thumbnail ? (
                              <span
                                style={{
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',

                                }}
                              >
                                <Avatar
                                  size={30}
                                  src={data?.author_image_thumbnail || profileDefaultImg}
                                  style={{ backgroundColor: 'transparent' }}
                                />
                              </span>
                            ) : (
                               <span
                                style={{
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <Avatar
                                  size={30}
                                  src={profileDefaultImg}
                                  style={{ backgroundColor: 'transparent' }}
                                />
                              </span>
                            )}

                            <div style={{ border: '' }}>
                              {data?.author_name && (
                                <span style={{ fontSize: '18px', fontWeight: 400 }}>
                                  {data?.author_name.charAt(0).toUpperCase() +
                                    data?.author_name.slice(1)}
                                </span>
                              )}
                              <span
                                style={{ color: '#6b7280', marginLeft: '.5rem', fontSize: '12px' }}
                              >
                                {formatDateBlog(data?.created_at)}
                              </span>
                            </div>
                            <div style={{ border: '2px ' }}>
                              {admin && (
                                <span style={{ color: data?.published ? 'green' : 'red' }}>
                                  {data?.published ? 'Published' : 'Unpublished'}
                                </span>
                              )}
                            </div>
                          </div>

                          <div style={{ border: '' }}>
                            <span
                              className="clamped-text"
                              style={{
                                fontSize: '1.4rem',
                                fontFamily: 'Sans-serif',
                                fontWeight: '400',
                                marginTop: '.5rem',
                                marginBottom: '.5rem',
                              }}
                            >
                              {data?.title
                                ? data.title.charAt(0).toUpperCase() + data.title.slice(1)
                                : ''}
                            </span>
                          </div>

                          {/* <div style={{ border: '2px solid purple ' ,padding: '.5rem'}}>
                            <span style={{ marginTop: '1rem' }}>Read More {'>'}</span>
                          </div> */}
                        </div>
                      </div>
                    </>
                  </Col>
                );
              })
            : !isBlogsLoading && (
                <div class="" style={{ columns: 'unset' }}>
                  <div
                    style={{
                      minHeight: '40vh',
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <h1>No Blogs Found</h1>
                  </div>
                </div>
              )}
        </Row>

        {/* Pagination  */}
        {blogs?.length > 0 && (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              fontFamily: 'Sans-serif',
              padding: '.7rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                padding: '0.5rem 1rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                backgroundColor: '#1c64f2',
                borderRadius: '5px',
              }}
            >
              {/* Previous Button */}
              <Button
                type="default"
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                style={{
                  backgroundColor: '#ffffff',
                  color: '#1c64f2',
                  borderColor: '#1c64f2',
                }}
                disabledStyle={{
                  backgroundColor: '#ffffff',
                  color: '#1c64f2',
                  borderColor: '#1c64f2',
                }}
              >
                &lt; Previous
              </Button>

              {/* Page Numbers */}
              <span
                style={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: '#374151',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '3px',
                  backgroundColor: '#ffffff',
                }}
              >
                {page}
              </span>

              {/* Next Button */}
              <Button
                type="default"
                disabled={Math.ceil(totalBlogs / Blog_per_page) <= page}
                onClick={() => setPage(page + 1)}
                style={{
                  backgroundColor: '#ffffff',
                  color: '#1c64f2',
                  borderColor: '#1c64f2',
                }}
              >
                Next &gt;
              </Button>
            </div>
          </div>
        )}
      </div>

      {/*       
      {isFetchingMore && totalBlogs > blogs.length && (
        <div
          style={{
            display: 'flex',
            backgroundColor: 'rgba(0,0,0,0.8)',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            position: 'fixed',
            zIndex: 999,
            top: 0,
            flexDirection: 'column',
          }}
        >
          <Spin />
          <strong
            className="capsule capsule_text"
            style={{ backgroundColor: '#1c64f2', fontSize: '1rem', color: 'white' }}
          >
            Fetching more blogs...
          </strong>
        </div>
      )} */}
    </>
  );
};

export default Blogs;
